import React from 'react'

import { useTranslation } from 'react-i18next'

import Tippy from '@tippyjs/react'
import { formatCommas } from '@utils/formatters/number.formatter'

import FacetTermList from './FacetTermList'
import useFilterItem from './hooks/useFilterItem'
import { facetTermDisplayText, getParamCategory } from './utils/helpers'
import { MusicType } from './utils/types'

import type { Facet, FacetTerm } from './utils/types'

interface Props {
  term: FacetTerm
  facet: Facet
  isFilterOpen: boolean
}

const FilterItem: React.FC<Props> = ({ facet, term, isFilterOpen }: Props) => {
  const { addFilter, removeFilter, count, selected, subFacet } = useFilterItem(facet, term)

  const { category } = facet
  const { key } = term

  const paramCategory = getParamCategory(facet)

  return (
    <li key={`${category}.${key}`} className="list-none pb-1.5 last:pb-0">
      {/* This is really a checkbox - might be tricky to make this more semantic? */}
      <button
        onClick={() => addFilter(paramCategory, key, selected)}
        key={key}
        className="flex items-end cursor-pointer text-md group">
        <p className="mr-2 dark:text-gray">
          {facetTermDisplayText(facet.category, term.key, facet.translationPrefix)}
        </p>
        {key === MusicType.ARRANGEME_CONTENT && <ArrangeMeInfo />}
        <p className="ml-1 mr-2 text-sm text-gray-text group-hover:text-black dark:group-hover:text-gray-dim">
          {formatCommas(count)}
        </p>
        {selected && (
          <i
            className="nf-icon nf-remove-sign text-orange text-md"
            onClick={() => removeFilter(paramCategory, key)}
          />
        )}
      </button>

      {/* Sub-Facets */}
      {selected && subFacet && (
        <FacetTermList
          facet={subFacet}
          isFilterOpen={isFilterOpen}
          hideExpander
          className="pl-3 py-1.5"
        />
      )}
    </li>
  )
}

export default FilterItem

function ArrangeMeInfo(): JSX.Element {
  const { t } = useTranslation()
  return (
    <Tippy arrow placement="bottom" maxWidth={220} content={t('content.arrangeMeSeparatePurchase')}>
      <i className="mr-0.5 nf-icon nf-help-sign self-center text-base" />
    </Tippy>
  )
}
